
/*
  This file is auto-generated by generate-icon-components.js. Do not edit it manually.
*/
import { html, css, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

export const FhiIconChevronsRightSelector = "fhi-icon-chevrons-right";

/**
 * ## FhiIconChevronsRight
 * 
 * {@link https://designsystem.fhi.no/?path=/docs/ikoner--docs}
 * 
 * @tag fhi-icon-chevrons-right
 * @element fhi-icon-chevrons-right
 */
@customElement(FhiIconChevronsRightSelector)
export class FhiIconChevronsRight extends LitElement {

  /**
   * Sets the color for the icon.
   * Should preferably be a color token. See [Color Tokens](https://designsystem.fhi.no/?path=/docs/design-tokens-farger--docs)
   * @type {string}
   */ 
  @property({ type: String }) color: string = "currentcolor";

  /**
   * Sets the size of the icon. Can be one of the predefined sizes, a number value, rem or px.
   * Number values are treated as px.
   * @type { 'xsmall' | 'small' | 'medium' | 'large' | number | string}
   */
  @property({ type: String }) size: 'xsmall' | 'small' | 'medium' | 'large' | number | `${number}px` | `${number}rem` = 'medium';

  private get _size(): string {
    switch (this.size) {
      case 'xsmall': 
        return '1rem'; 
      case 'small':
        return '1.25rem';
      case 'medium':
        return '1.5rem'; 
      case 'large':
        return '2rem'; 
      default:
        if (String(this.size).endsWith('px') || String(this.size).endsWith('rem')) {
          return String(this.size);
        }
        if (isNaN(Number(this.size))) {
          console.warn(`Invalid size value: ${this.size}. Falling back to default size '1.5rem'.`)
          return '1.5rem';
        }
        return `${this.size}px`;
    }
  }

  render() {
    return html`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${this._size}" height="${this._size}" fill="${this.color}"><path d="M5.47 6.47a.75.75 0 0 1 1.004-.052l.056.052 5 5 .052.056a.75.75 0 0 1 0 .948l-.052.056-5 5a.75.75 0 1 1-1.06-1.06L9.94 12 5.47 7.53l-.052-.056A.75.75 0 0 1 5.47 6.47m7 0a.75.75 0 0 1 1.004-.052l.056.052 5 5 .052.056a.75.75 0 0 1 0 .948l-.052.056-5 5a.75.75 0 1 1-1.06-1.06L16.94 12l-4.47-4.47-.052-.056a.75.75 0 0 1 .052-1.004"/></svg>
    `;
  }
      
  static styles = css`
    :host {
      display: flex;
      max-height: min-content;
      max-width: min-content;
    }
  `;
  }
